export const getEditResultOpen = state => state.uiReducer.editResultOpen;
export const getEditResultMatchId = state => state.uiReducer.editResultMatchId;

export const getPasswordDialogOpen = state =>
  state.uiReducer.passwordDialogOpen;
export const getPasswordDialogMatchId = state =>
  state.uiReducer.passwordDialogMatchId;
export const getPasswordDialogAction = state =>
  state.uiReducer.passwordDialogAction;

export const getToastMessage = state => state.uiReducer.toastMessage;



// WEBPACK FOOTER //
// ./src/store/ui/uiSelectors.js